<div class="skeleton">
  <div class="skeleton__header skeleton--animated"></div>
  <div class="skeleton__chart skeleton--animated"></div>
</div>
